import { Base64 } from 'js-base64';

export default class common {

    static BaseName = '/appVend';  //开发环境
    //static BaseName = '';  //生产环境

    static SUCCESS = 'app_success';
    static WARNING = 'app_warning';
    static ERROR = 'app_error';

    static SUPPLIER_TYPE = {
        1: '设备商', 2: '运维商', 3: '原料商'
    }

    static secret_key = 'yllsy-2019';

    static getlocalItem = key => {
        let data = localStorage.getItem(key);
        if (data) {
            let str = this.Secret_Key(data, this.secret_key, 'D');
            return JSON.parse(str);
        } else {
            return null;
        }
    }

    static setLocalItem = (key, value) => {
        let jsonstr = JSON.stringify(value);
        let str = this.Secret_Key(jsonstr, this.secret_key, 'E');
        localStorage.setItem(key, str);
    }

    static removeLocalItem = key => {
        if (key) {
            localStorage.removeItem(key);
        } else {
            localStorage.clear();
        }
    }

    static myMenus = null;

    static AUTH_URL = url => {
        let flag = false;
        if (!this.myMenus) {
            this.myMenus = this.getMenuUrls();
        }
        if (this.myMenus) {
            if (this.myMenus[url]) {
                flag = true;
            }
        }
        return flag;
    }

    /**
    * JS字符串加密和解密
    * @param    {[string]} [str] [需要加密/解密的字符串（包括中文）]
    * @param    {[string]} [pwd] [密码]
    * @param    {[string]} [type] [类型：E = 加密 、D = 解密]
    * @return   {[string]}   
    */
    static Secret_Key = (str, pwd, type) => {
        if (type == 'E') {   //加密
            str = Base64.encode(str);//Base64加密
            let prand = "";
            for (let i = 0; i < pwd.length; i++) {
                prand += pwd.charCodeAt(i).toString();
            }
            let sPos = Math.floor(prand.length / 5);
            let mult = parseInt(prand.charAt(sPos) + prand.charAt(sPos * 2) + prand.charAt(sPos * 3) + prand.charAt(sPos * 4) + prand.charAt(sPos * 5));
            let incr = Math.ceil(pwd.length / 2);
            let modu = Math.pow(2, 31) - 1;
            if (mult < 2) {
                alert("Please choose a more complex or longer password.");
                return null;
            }
            let salt = Math.round(Math.random() * 1000000000) % 100000000;
            prand += salt;
            while (prand.length > 10) {
                prand = (parseInt(prand.substring(0, 10)) + parseInt(prand.substring(10, prand.length))).toString();
            }
            prand = (mult * prand + incr) % modu;
            let enc_chr = "";
            let enc_str = "";
            for (let i = 0; i < str.length; i++) {
                enc_chr = parseInt(str.charCodeAt(i) ^ Math.floor((prand / modu) * 255));
                if (enc_chr < 16) {
                    enc_str += "0" + enc_chr.toString(16);
                } else enc_str += enc_chr.toString(16);
                prand = (mult * prand + incr) % modu;
            }
            salt = salt.toString(16);
            while (salt.length < 8) salt = "0" + salt;
            enc_str += salt;
            return enc_str;
        }
        if (type == 'D') {  //解密
            let prand = "";
            for (let i = 0; i < pwd.length; i++) {
                prand += pwd.charCodeAt(i).toString();
            }
            let sPos = Math.floor(prand.length / 5);
            let mult = parseInt(prand.charAt(sPos) + prand.charAt(sPos * 2) + prand.charAt(sPos * 3) + prand.charAt(sPos * 4) + prand.charAt(sPos * 5));
            let incr = Math.round(pwd.length / 2);
            let modu = Math.pow(2, 31) - 1;
            let salt = parseInt(str.substring(str.length - 8, str.length), 16);
            str = str.substring(0, str.length - 8);
            prand += salt;
            while (prand.length > 10) {
                prand = (parseInt(prand.substring(0, 10)) + parseInt(prand.substring(10, prand.length))).toString();
            }
            prand = (mult * prand + incr) % modu;
            let enc_chr = "";
            let enc_str = "";
            for (let i = 0; i < str.length; i += 2) {
                enc_chr = parseInt(parseInt(str.substring(i, i + 2), 16) ^ Math.floor((prand / modu) * 255));
                enc_str += String.fromCharCode(enc_chr);
                prand = (mult * prand + incr) % modu;
            }
            return Base64.decode(enc_str);
        }
    }

    static getMenuUrls = () => {
        let menus = this.getlocalItem('auth-menus');
        let obj = {};
        if (menus && menus.length > 0) {
            menus.forEach(item => {
                obj[item.url] = item.id;
            });
        }
        return obj;
    }

    static menus = this.getlocalItem('auth-menus') ? this.getMenuUrls(this.getlocalItem('auth-menus')) : [];
    //商品类型KEY
    static GOOD_TYPE = "good_type";

    //商品规格类型KEY
    static GOOD_SPEC_TYPE = "good_spec_type";

    //页面请求的项目地址  /dcloud-app-vend-portal/
    static PROJECTS_URL = "/dcloud-app-vend-portal/";

    /** 系统消息 */
    static SYS_MESSAGE = 1;

    /** 通知消息 */
    static NOTICE_MESSAGE = 2;

    /** 业务消息 */
    static BUSINESS_MESSAGE = 3;

    /** 发送的消息记录 */
    static SEND_MESSAGE = 4;

    static DEVICE_POWER = {
        0: '隐藏',
        1: '公开'
    }

    static DEVICE_REPAIR_STATUS = {
        1: "一级未接单",
        2: "一级已接单",
        3: "一级已完修",
        4: "已取消",
        5: '二级未接单',
        6: '二级已接单',
        7: '二级已完修',
    }

    static MESSAGE_CLASSTIY = {
        1: '系统消息',
        2: '通知',
        3: '业务',
        4: '发送',
    }

    static MESSAGE_FLAG = {
        0: '未读',
        1: '已读',
    }

    static JH_STATUS = {
        0: '完成',
        1: '已提交',
        2: '已审核',
    }
    //测点数据质量戳
    static POINT_QS = {
        "-4": "错误响应",
        "-3": "断连",
        "-2": "坏点",
        "0": "好点",
        "1": "非法功能",
        "2": "非法数据地址",
        "3": "非法数据值",
        "4": "从站设备故障",
        "5": "确认",
        "6": "从属设备忙 ",
        "8": "存储奇偶性差错 ",
        "10": "不可用网关路径 ",
        "11": "网关目标设备响应失败"
    }

    //报警状态
    static ALARM_STATUS = {
        "-1": "正常",
        "1": "高报",
        "2": "低报",
        "3": "开报",
        "4": "关报",
        "5": "规则报警"
    }

    //日志类型
    static LOG_TYPE = {
        "9": "控制"
    }

    //订单状态：1-待支付，2-支付成功，3-支付失败,4-下发成功，5-下发失败，6-退款成功，7-退款失败
    static ORDER_STATUS = {
        "1": "待支付",
        "2": "支付成功",
        "3": "支付失败",
        "4": "打杯成功",
        "5": "打杯失败",
        "6": "退款成功",
        "7": "退款失败",
        "8": "打杯中",
        "9": "退款待确认",
        "10": "打杯超时"
    }

    //支付方式：1-微信，2-支付宝
    static PAY_MODE__STATUS = {
        "1": "微信",
        "2": "支付宝",
        "3": "金币",
        "4": "银联支付",
        "5": "免费"
    }

    //支付状态：1-待支付，2-支付成功，3-支付失败
    static PAY__STATUS = {
        "1": "待支付",
        "2": "支付成功",
        "3": "支付失败"
    }

    //下发状态：1-下发成功，2-下发失败
    static DOWN__STATUS = {
        "1": "下发成功",
        "2": "下发失败",
    }

    //退款状态:1-退款成功，2-退款失败
    static REFUND__STATUS = {
        "1": "退款成功",
        "2": "退款失败",
    }

    //退款错误提示
    static REFUND_ERR = {
        'refund_err_01': '订单号为空',
        'refund_err_02': '退款金额为空',
        'refund_err_03': '退款金额格式错误',
        'refund_err_04': '订单不存在',
        'refund_err_05': '订单不支持退款',
        'refund_err_06': '订单已经退过款',
        'refund_err_07': '退款金额大于支付金额',
        'refund_err_08': '退款失败',
        'refund_err_09': '退款成功'
    }

    static PROPORTION = {
        1: "设备商",
        2: "亿联",
        3: "门店高层客户",
    }

    //消息类型
    static MESSAGE_TYPE = {
        "1": "设备故障消息",
        "6": "设备报警消息",
        "2": "业务告警消息",
        "3": "订单流程消息",
        // "4" : "退款消息",
    }

    //通知方式
    static SEND_TYPE = {
        "1": "邮件",
        "2": "短信",
        "3": "微信"
    }

    //用户权限
    static Permissions = new Map();

    //商品上架错误标识
    static SHELF_STATUS = {
        1: '下发设备参数成功',
        2: '未找到需要下发的参数',
        3: '未匹配到设备中的测点',
        4: '设置测点不存在',
        5: '请取消设备控制密码',
        6: '数据格式不正确',
        7: '下发参数值失败',
        8: '未找到商品规格',
        9: '设备下发参数成功',
        0: '设备下发参数成功',
        10: '上架成功',
        11: '上架添加数据失败',
        12: '未找到规格参数匹配的测点',
        13: '未找到规格参数',
    }

    static POINT_TYPES = {
        1: '整型(32位)',
        2: '整型(64位)',
        3: '浮点(32位)',
        4: '数字',
        5: '开关',
        6: '字符串',
        7: '定位型',
        8: '波形'
    }

    static SERVICE_MODE = {
        1: '固定年费',
        2: '固定分成',
        3: '阶梯分成',
    }

    static COST_DEV_ORDER_TYPE = {
        1: '固定年费',
        2: '固定分成',
        3: '阶梯分成',
        4: '短信费',
        5: '扩容费',
    }

    static COST_DEV_STATUS = {
        1: '正常',
        2: '欠费',
        3: '试用',
        4: '已过期',
        0: '不限制',
    }

    static COST_DEV_ORDER_STATUS = {
        1: '待⽀付',
        2: '已⽀付',
        3: '已取消',
    }
}

